var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    { attrs: { titleType: "custom" } },
    [
      _c("template", { slot: "header-title" }, [
        _c("div", { staticClass: "header-title-left" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("Integrations.pageHeader_Franchise"))),
          ]),
        ]),
      ]),
      _c(
        "template",
        { slot: "content-center" },
        [
          !_vm.franchiseList.length
            ? _c("EmptyState", {
                attrs: {
                  iconName: "empty-state-franchise",
                  title: _vm.$t(
                    "Integration.emptyState_Franchise_NotFound_Title"
                  ),
                  description: _vm.$t(
                    "Integration.emptyState_NotFound_Franchise_Description_Order"
                  ),
                },
              })
            : _c("div", { staticClass: "franchise-table" }, [
                _c("div", { staticClass: "head" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col u-textCenter franchise" }, [
                      _vm._v(_vm._s(_vm.$t("Integration.isFranchise"))),
                    ]),
                    _c("div", { staticClass: "col storeGroup" }, [
                      _vm._v(_vm._s(_vm.$t("Dictionary.StoreGroup"))),
                    ]),
                    _c("div", { staticClass: "col u-textRight" }, [
                      _vm._v(_vm._s(_vm.$t("Integration.budget"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col u-textCenter can-exceed-limit" },
                      [_vm._v(_vm._s(_vm.$t("Integration.canExceedLimit")))]
                    ),
                    _c("div", { staticClass: "col u-textRight" }, [
                      _vm._v(_vm._s(_vm.$t("Integration.limitPercentage"))),
                    ]),
                    _c("div", { staticClass: "col" }),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "body" },
                  _vm._l(_vm.franchiseList, function (row, index) {
                    return _c(
                      "div",
                      {
                        key: row.id,
                        staticClass: "row",
                        attrs: { id: `table-body-row-franchise-list-${index}` },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col u-textCenter franchise" },
                          [
                            _c("SwitchButton", {
                              staticClass: "switch-button",
                              attrs: {
                                active: row.isFranchise,
                                id: "btn-dashboard-switch-status",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleFranchise(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col storeGroup" }, [
                          _vm._v(_vm._s(row.storeGroupName)),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "col u-textRight",
                            attrs: {
                              id: `from-store-name-requested-transfer-${index}`,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "currency-input" },
                              [
                                _c("currency-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "greater_than:0",
                                      expression: "'greater_than:0'",
                                    },
                                  ],
                                  staticClass: "txt",
                                  class: {
                                    "is-danger": _vm.veeErrors.has(
                                      `franchiseBudget-${row.index}-${row.storeGroupId}`
                                    ),
                                  },
                                  attrs: {
                                    name: `franchiseBudget-${row.index}-${row.storeGroupId}`,
                                    id: "franchise-budget",
                                    disabled: !row.isFranchise,
                                    "data-vv-as": _vm.$t(
                                      "Integration.franchiseBudget"
                                    ),
                                    error: _vm.veeErrors.has(
                                      `franchiseBudget-${row.index}-${row.storeGroupId}`
                                    ),
                                  },
                                  model: {
                                    value: row.budget,
                                    callback: function ($$v) {
                                      _vm.$set(row, "budget", $$v)
                                    },
                                    expression: "row.budget",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "currency-input-symbol",
                                    class: !row.isFranchise
                                      ? "passive-currency-symbol"
                                      : "",
                                  },
                                  [_vm._v(" " + _vm._s("₺"))]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col u-textCenter can-exceed-limit",
                            attrs: {
                              id: `store-name-requested-transfer-${index}`,
                            },
                          },
                          [
                            _c("CustomCheckbox", {
                              attrs: {
                                label: "",
                                checked: row.canExceedLimit,
                                disabled: !row.isFranchise,
                                id: "btn-can-exceed-limit-checkbox",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeExceedCondition(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col u-textRight",
                            attrs: {
                              id: `limit-percentage-franchise-${index}`,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "control" },
                              [
                                _c("customNumberInput", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "numeric|min_value:0",
                                      expression: "'numeric|min_value:0'",
                                    },
                                  ],
                                  attrs: {
                                    name: `limitPercentage-${row.index}-${row.storeGroupId}`,
                                    id: "franchise-limit-percentage",
                                    isTypePercentage: true,
                                    "data-vv-as": _vm.$t(
                                      "Integration.limitPercentage"
                                    ),
                                    error: _vm.veeErrors.has(
                                      `limitPercentage-${row.index}-${row.storeGroupId}`
                                    ),
                                    disabled:
                                      !row.isFranchise || !row.canExceedLimit,
                                  },
                                  model: {
                                    value: row.limitPercentage,
                                    callback: function ($$v) {
                                      _vm.$set(row, "limitPercentage", $$v)
                                    },
                                    expression: "row.limitPercentage",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("Button", {
                              staticClass: "m-left-10",
                              attrs: {
                                primary: "",
                                size: "small",
                                tabindex: "-1",
                                id: `button-integration-submit`,
                                variant: "icon",
                                iconName: "icon-btn-success",
                                justIcon: true,
                                iconClass: "icon-btn-success",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.saveFranchise(row, index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }